module.exports = __webpack_public_path__ + "static/media/fuelForecast.b6c07cac.svg";